// extracted by mini-css-extract-plugin
export var container = "_sc-0";
export var table = "_sc-2";
export var tableWrapper = "_sc-1";